export const darkTheme = {
  bg: "#0A0A1B",
  bgLight: "#151528",
  primary: "#8B5CF6",
  primary_light: "#A78BFA",
  secondary: "#EC4899",
  text_primary: "#F3F4F6",
  text_secondary: "#9CA3AF",
  card: "#1F1F3D",
  button: "#8B5CF6",
  button_text: "#FFFFFF",
  button_secondary: "#EC4899",
  button_secondary_text: "#FFFFFF",
  navbar: "rgba(10, 10, 27, 0.8)",
  divider: "rgba(139, 92, 246, 0.1)",
  input_bg: "#151528",
  input_border: "#8B5CF6",
  yellow: "#A78BFA",
  arrow: "#9CA3AF",
  menu_primary_text: "#F3F4F6",
  black: "#000000",
  white: "#FFFFFF",
  error: "#EF4444",
  success: "#10B981",
};




export const lightTheme = {
  bg: "#f9f9f9",
  bgLight: "#FFFFFF",
  primary: "#007AFF",
  secondary: "#9747FF",
  disabled: "#b1b2b3",
  navbar: "#242B3F",
  arrow: "#AFAFB5",
  menu_primary_text: "#F2F3F4",
  menu_secondary_text: "#b1b2b3",
  table_header: "#242445",
  text_primary: "#404040",
  text_secondary: "#4d4c4c",
  card: "#FFFFFF",
  black: "#000000",
  white: "#FFFFFF",
  shadow: "#00000020",
  green: "#00ff6a",
  yellow: "#e8ba00",
  red: "#ef5350",
  orange: "#F7AD63",
};